const stamp = process.env.BUILD_TIMESTAMP ?? "0";

/** Append cache-bust query string to a single resource path. */
export function cacheBust(path: string): string {
	return `${path}?v=${stamp}`;
}

/** Cache-bust all `image` and `thumbnailImage` fields in a values record. */
export function cacheBustValueImages<
	T extends Record<string, { image?: string; thumbnailImage?: string }>,
>(record: T): T {
	return Object.fromEntries(
		Object.entries(record).map(([key, value]) => [
			key,
			{
				...value,
				...(value.image != null && { image: cacheBust(value.image) }),
				...(value.thumbnailImage != null && {
					thumbnailImage: cacheBust(value.thumbnailImage),
				}),
			},
		]),
	) as T;
}

/** Cache-bust an array of path strings. */
export function cacheBustPaths(paths: readonly string[]): string[] {
	return paths.map(cacheBust);
}
